<template>
  <v-tooltip bottom :open-delay="actualOpenDelay">
    <template v-slot:activator="{ on }">
      <v-btn
          :id="actualId"
          v-on="on"
          icon
          @click="$emit('click')"
          @mouseenter="over = true"
          @mouseleave="over = false"
          :color="actualColor"
          :forceMouseOverColor="forceMouseOverColor"
          :disabled="actualDisabled"
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: ["id", "color", "mouseOverColor", "icon", "tooltip", "disabled", "forceMouseOverColor", "openDelay", "position"],
  data() {
    return {
      over: false
    }
  },
  computed: {
    actualColor() {
      if (this.over || this.forceMouseOverColor) {
        return this.mouseOverColor ? this.mouseOverColor : "primary"
      } else {
        return this.color ? this.color : "grey"
      }
    },
    actualId() {
      return this.id ? this.id : "tooltip_btn"
    },
    actualDisabled() {
      return this.disabled == null || this.disabled === undefined ? false : this.disabled
    },
    actualOpenDelay() {
      return this.openDelay ? this.openDelay : 100
    },
  },
}
</script>